import React from 'react'
import LazyLoad from '../LazyLoad'

export const Actions = ({
  actions,
  selectedFilters,
  setSelectedFilters,
  actionsMock,
}) => {
  const onPress = (item) => {
    setSelectedFilters({ ...selectedFilters, action: item })
  }

  const renderData = () => {
    if (!actionsMock?.length) {
      return <LazyLoad size={6} />
    }
    if (!actions?.length) {
      return renderList(actionsMock)
    }
    return renderList(actions)
  }

  const renderList = (data) => {
    const isDisabled = !actions.length
    return data.map((action, idx) => {
      const isSelected = !isDisabled && action === selectedFilters.action

      return (
        <div
          key={action}
          onClick={() => {
            if (isDisabled) return
            onPress(action)
          }}
          className="PreflopCharts__button"
          style={{
            borderWidth: isSelected ? '2px' : 0,
            opacity: isDisabled ? 0.3 : 1,
          }}
        >
          <div
            className="PreflopCharts__button-label"
            style={{
              color: isSelected ? '#0085FF' : 'black',
            }}
          >
            {action}
          </div>
        </div>
      )
    })
  }

  return (
    <div
      style={{
        fontSize: '16px',
        fontFamily: ' Roboto, sans-serif',
        width: '100%',
      }}
      className="ClearTheCharts__label"
    >
      <p>Action</p>
      <div className="PreflopCharts__options-row">{renderData()}</div>
    </div>
  )
}
